import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import { ValidationProvider } from 'vee-validate'
import Vue2Filters from 'vue2-filters'
import DatetimePicker from 'vuetify-datetime-picker'
import VueMoment from 'vue-moment'
import VueLazyLoad from 'vue-lazyload'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import UniqueId from 'vue-unique-id'
 
import 'vuetify/dist/vuetify.min.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

Vue.use(Viewer, {
  debug: true,
  defaultOptions: {
    zIndex: 9999
  }
})

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

import JsonExcel from "vue-json-excel";
 
Vue.component("downloadExcel", JsonExcel);

Vue.use(Vue2Filters)
Vue.use(DatetimePicker)
Vue.use(VueMoment)
Vue.use(VueLazyLoad)
Vue.use(UniqueId)

require('@/store/subscriber')

axios.defaults.baseURL = 'https://tasks.bigcitymarketing.co/api'
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('FilePond', FilePond)

var truncate = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', truncate);

var capitalize = function(value){
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
};

Vue.filter('capitalize', capitalize);

var separate = function(value){
  if (!value) return ''
  value = value.replace(/_/g, ' ')
  return value.charAt(0).toUpperCase() + value.slice(1)
};

Vue.filter('separate', separate);

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDW1KubYrb18yv4VHM-CKAyeYrwVv26Qis', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  installComponents: true, // Optional (default: true) - false, if you want to locally install components
  vueGoogleMapsCompatibility: false, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
});

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})

